<template>
  <div class="property-input">
    <label class="property-label">
      {{ property.text ? property.text : property.name }}
      <Tooltip v-if="property.tooltip" :text="property.tooltip" />
    </label>
    <input 
      type="text" 
      :value="element" 
      @input="updateValue($event.target.value)"
      class="property-text-input"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import * as namespaceStore from "../../vuexStore/namespaceStore.js"
import * as actions from "../../vuexStore/actions.js"
import Tooltip from "../Tooltip.vue";

export default {
  name: 'TextInput',
  props: {
    property: {
      type: Object,
      required: true
    },
    element: {
      type: String,
      required: true
    },
    container: {
      type: Object,
      required: true
    },
    eventOnChangeRessource: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  components: {
    Tooltip
  },
  methods: {
    ...mapActions(namespaceStore.THEME, {
      'updateProperty': actions.UPDATE_PROPERTY
    }),
    updateValue(value) {
      if (this.eventOnChangeRessource == false) {
        this.updateProperty({element: this.container, property: this.property, value: value})
      }
      else {
        this.$emit('eventOnChangeRessource', value)
      }
    }
  }
}
</script>

<style scoped>
.property-input {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
  padding: 0.25rem;
  font-size: 15px;
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 0.375rem;
}

.property-label {
  font-size: 1rem;
  text-shadow: 0 0 10px rgba(0, 0, 0, 1);
  color: #e5e7eb;
  display: flex;
  justify-content: space-between;
}

.property-text-input {
  padding: inherit;
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 0.25rem;
  color: #e5e7eb;
  transition: all 0.2s ease;
}

.property-text-input:focus {
  outline: none;
  border-color: #3b82f6;
  background-color: rgba(255, 255, 255, 0.15);
}

.property-text-input:hover {
  background-color: rgba(255, 255, 255, 0.15);
}
</style>

